import { render, staticRenderFns } from "./FotoSelfie.vue?vue&type=template&id=56808acf&scoped=true&"
import script from "./FotoSelfie.vue?vue&type=script&lang=js&"
export * from "./FotoSelfie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56808acf",
  null
  
)

export default component.exports